import { styled } from '@creditas/stylitas';
import tokens from '@creditas/tokens';

const ErrorMessageContainer = styled.div`
  background-color: ${tokens.bColorneutral01};
`;

export { ErrorMessageContainer };
